import { colors } from '../../../../constants/colors';

export const classes = {
  root: {
    padding: '24px 24px 32px',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    rowGap: 3,
    marginTop: 3,
    textAlign: 'center',
  },
  title: {
    fontWeight: 500,
    fontSize: 24,
    lineHeight: 1.5,
    color: colors.oxford,
    opacity: 0.8,
  },
  subtitle: {
    display: 'flex',
    flexDirection: 'column',
    fontWeight: 400,
    fontSize: 16,
    lineHeight: 1.56,
    letterSpacing: '0.25px',
    color: colors.oxford_60,
  },
  email: {
    fontWeight: 600,
    fontSize: 16,
    lineHeight: 1.56,
    letterSpacing: '0.25px',
    color: colors.oxford,
    opacity: 0.8,
  },
  reminder: {
    display: 'flex',
    flexDirection: 'column',
    fontWeight: 400,
    fontSize: 16,
    lineHeight: 1.56,
    letterSpacing: '0.25px',
    color: colors.oxford_60,
  },
};
